module.exports = __webpack_public_path__ + "media/images/photos/22-14ab40af9739bb9b3278ebf1a298f8c2.jpg";